import React from "react";

import Modal from "../Modal";
import Button from "../Button";

import request from "../../utils/request";
import { setStoreModal , getStoreModal } from "../../utils/SettingsRetriever";

export default class MultiStore extends React.Component{
    constructor(props){
        super(props);

        this.state = {};
    }

    componentDidMount(){
        if ( ( (getStoreModal() && getStoreModal() + 86400) < (new Date().getTime() / 1000) ) || !getStoreModal() ){
            if (this.props.settings && this.props.settings.app && this.props.settings.app.multistore_popup && this.props.settings.app.multistore_popup.enabled){
                let customField = this.props.settings.app.multistore_popup.field;
                let multistore = this.props.settings.app.multistore_popup;
                request({
                    url: 'https://kymguavwd7.execute-api.us-east-1.amazonaws.com/ip/',
                    method: 'GET'
                })
                .then(r => {
                    request({
                        url: `${multistore.geoip_endpoint}?ip=${r.data.ip}`,
                        method: 'GET'
                    })
                    .then(res => {
                        if (res.data[customField] === multistore.geoip){
                            this.setState({ modal: true, multistore });
                        }
                    })
                })
            }
        }
    }

    setStore = (domain) => {
        setStoreModal(new Date().getTime() / 1000);
    
        // Get the current query string
        const currentQueryString = window.location.search;
        // Append the current query string to the domain
        const newUrl = `${domain}${window.location.pathname}/${currentQueryString}`;
        
        // Redirect to the new URL with the query string
        window.location.href = newUrl;
    }

    render(){
        const { modal, multistore } = this.state;
        if (!multistore) return null;
        return (
            <Modal
                className="storeModal"
                container={document.getElementsByClassName("main-application")[0]}
                open={modal}
                title={multistore.title}
                closeFn={() => this.setState({ modal: false })}
            >
                <div className="body">
                    {
                        multistore.message &&
                        <p className="message">
                            {multistore.message}
                        </p>
                    }
                    <div className="stores">
                        {
                            multistore.stores.map((store, idx) => {
                                return (
                                    <Button
                                        key={"store_" + idx} 
                                        className="store"
                                        onClick={() => this.setStore(store.domain)}
                                    >
                                        <img src={store.flag} alt={store.title} />
                                        <span>{store.title}</span>
                                    </Button>
                                )
                            })
                        }
                    </div>
                </div>
            </Modal>
        )
    }
}